import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadSession } from "../../store/actions/chatbot";
import dayjs from "dayjs";
import isToday from "dayjs/plugin/isToday";
import isYesterday from "dayjs/plugin/isYesterday";

dayjs.extend(isToday);
dayjs.extend(isYesterday);

function formatDate(dateStr) {
  const d = dayjs(dateStr);
  if (d.isToday()) return "Today, " + d.format("h:mm A");
  if (d.isYesterday()) return "Yesterday, " + d.format("h:mm A");
  return d.format("DD MMM YYYY");
}

function ChatHistoryList() {
  const dispatch = useDispatch();
  const sessions = useSelector((s) => s.chatbot.sessions);

  if (!sessions.length) {
    return <div className="chat-history-empty">No previous chats yet.</div>;
  }

  return (
    <div className="chat-history-list">
      {sessions.map((session) => (
        <div
          key={session.session_id}
          className="chat-history-item"
          onClick={() => dispatch(loadSession(session.session_id))}
        >
          <div className="chat-history-item__title">
            {session.title || "Untitled chat"}
          </div>
          <div className="chat-history-item__date">
            {formatDate(session.updated_on || session.created_on)}
          </div>
        </div>
      ))}
    </div>
  );
}

export default ChatHistoryList;
